var _a;
import InviteFriendsModal from "./modalContents/invite-friends";
import DraftsModal from "./modalContents/draft-list";
import { ModalKeys } from "./modalKeys";
var inviteFriendsModalEntry = {
    component: InviteFriendsModal,
    defaultOptions: {
        hideHeader: true,
        closeButtonRequired: true,
        size: "lg",
    },
};
export var modalRegistry = (_a = {},
    _a[ModalKeys.SHARE_TRIP] = inviteFriendsModalEntry,
    _a[ModalKeys.INVITE_USERS] = inviteFriendsModalEntry,
    _a[ModalKeys.DRAFTS] = {
        component: DraftsModal,
        defaultOptions: {
            title: "Saved Drafts",
            closeButtonRequired: true,
            size: "md",
        },
    },
    _a);
